import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { icons } from '@tsq-web/assets';
import { TSqValidators } from '@tsq-web/forms';

import {
  getPasswordErrorMessage$,
  getPasswordRequirements$,
} from '../../../shared/password/utils/password-requirement';

@Component({
  selector: 'comm-user-recovery-new-password-form',
  templateUrl: './new-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewPasswordFormComponent {
  @Input() isLoading = false;

  @Output() backToLogin = new EventEmitter<void>();
  @Output() changePassword = new EventEmitter<string>();

  readonly icons = icons;

  readonly changePasswordForm = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(/^\S*$/),
      TSqValidators.matchPasswordValidator('passwordConfirm', true),
    ]),
    passwordConfirm: new FormControl('', [TSqValidators.matchPasswordValidator('password')]),
  });

  readonly passwordRequirements$ = getPasswordRequirements$(this.changePasswordForm);
  readonly errorMessage$ = getPasswordErrorMessage$(this.passwordRequirements$);
}
